import { render, staticRenderFns } from "./LayoutBackHeader.vue?vue&type=template&id=55bd4a60&scoped=true&"
import script from "./LayoutBackHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutBackHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBackHeader.vue?vue&type=style&index=0&id=55bd4a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd4a60",
  null
  
)

export default component.exports